/**
 * @generated SignedSource<<219f1a51205366530f236031ca2c4155>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SlackUserImportStatus = "cancelled" | "completed" | "failed" | "initial" | "inprogress" | "needsmapping" | "%future added value";
export type CreateSlackUserImportInput = {
  organizationId: string;
};
export type CreateSlackUserImportButtonMutation$variables = {
  input: CreateSlackUserImportInput;
};
export type CreateSlackUserImportButtonMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly id: string;
      readonly status: SlackUserImportStatus;
    } | null;
  };
};
export type CreateSlackUserImportButtonMutation = {
  response: CreateSlackUserImportButtonMutation$data;
  variables: CreateSlackUserImportButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateSlackUserImportResponse",
    "kind": "LinkedField",
    "name": "createSlackUserImport",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SlackUserImport",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateSlackUserImportButtonMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateSlackUserImportButtonMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fa4f082123342c05e399783454e737f4",
    "id": null,
    "metadata": {},
    "name": "CreateSlackUserImportButtonMutation",
    "operationKind": "mutation",
    "text": "mutation CreateSlackUserImportButtonMutation(\n  $input: CreateSlackUserImportInput!\n) {\n  response: createSlackUserImport(input: $input) {\n    node {\n      id\n      status\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3582a951f28684bc9b5d95e9150e9baa";

export default node;
